module.exports = __webpack_public_path__ + "img/9788971994344.e8264d78.jpg";